<script setup>
import axios from 'axios';
import { onMounted, onUnmounted, ref } from 'vue';
import Loading from '../../Loading.vue';

const eventData = ref(false);
const isLoading = ref(true);
// A slow answer can land after these screens have gone, and would then paint
// the background behind the portal with nothing left to clear it.
let gone = false;
function getData() {
    axios.get(`${window.store.event_backend_api}/register-settings`)
        .then(res => {
            if (gone) return;
            eventData.value = res.data.data;
            document.body.style.backgroundImage = `url(${res.data.data.background_image})`;
        }).finally(() => {
            isLoading.value = false;
        });
};

onMounted(() => {
    getData();
});

// The sign-in background belongs to these screens only (XN-4554 AC 8);
// without this it stays on <body> behind the portal after login.
onUnmounted(() => {
    gone = true;
    document.body.style.backgroundImage = '';
});
</script>
<template>
    <div class="content">
        <div id="login-container">
            <Loading v-if="isLoading" variant="lines" :rows="4" />
            <router-view v-else :eventData="eventData"></router-view>
        </div>
    </div>
</template>

<style>
body {
    height: 100vh;
    margin: 0;
    font-family: 'Lato', sans-serif;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
}

.bg-white {
    background: white;
    width: 100%;
}

.logo {
    margin-bottom: 0 !important;
}
</style>
<style lang="scss" scoped>
.content {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5em 0;
    height: 100%;

    #login-container {
        border-radius: 12px;
        background: #FFF;
        box-shadow: 0px 2px 6px 2px rgba(0, 0, 0, 0.15);
        width: 435px;
        min-width: 340px;
        max-width: 100%;
        padding: 40px;
    }
}
</style>